/**
 * Get a translated string from state.translatedText by UID and language
 * @param {Object} translatedText - The translatedText object from state
 * @param {number|string|null} uid - The string UID
 * @param {string} lang - The language code (e.g., 'en', 'fr')
 * @returns {string|undefined} The translated string, or debug message in non-production if not found
 */
export default function getTranslatedString(translatedText, uid, lang) {
  // In production, return undefined for any missing data
  if (process.env.NODE_ENV === 'production') {
    if (!uid || uid === null || !translatedText) {
      return undefined;
    }
    const stringObj = translatedText[uid];
    if (!stringObj) {
      return undefined;
    }
    const translatedString = stringObj[lang];
    return translatedString || undefined;
  }

  // Non-production: always show debug info explaining what's missing
  if (!uid || uid === null) {
    return 'Missing String ID: null (UID not set)';
  }

  if (!translatedText) {
    return `Missing String ID: ${uid} (translatedText not available)`;
  }

  const stringObj = translatedText[uid];
  if (!stringObj) {
    return `Missing String ID: ${uid} (string not found in translatedText)`;
  }

  const translatedString = stringObj[lang];
  if (!translatedString) {
    return `Missing String ID: ${uid} (translation not found for language: ${lang})`;
  }

  return translatedString;
}
